<script lang="ts" setup>
import { useWindowSize } from '@vueuse/core';

const { height } = useWindowSize();
</script>
<template>
  <a-back-top
    class="!bottom-[188px] !right-[40px] !h-[44px] !w-[44px]"
    :visibility-height="height"
  >
    <template #icon>
      <img src="@core/assets/image/icon/icon-backtop.svg" />
    </template>
  </a-back-top>
</template>
<style scoped>
:deep(.ant-float-btn-body .ant-float-btn-content) {
  padding: 0 !important;
}
:deep(.ant-float-btn-body .ant-float-btn-content .ant-float-btn-icon) {
  width: 44px !important;
}
</style>
